import { NgModule } from "@angular/core";
import { CoreComponent } from "./core.component";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "../auth/_guards/auth.guard";
import { ReferEarnComponent } from "./pages/refer-earn/refer-earn.component";

const routes: Routes = [
    {
        path: "",
        component: CoreComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: "index",
                loadChildren: "./pages/default/blank/blank.module#BlankModule",
            },
            {
                path: "dashboard",
                loadChildren: "./pages/dashboard/dashboard.module#DashboardModule",
            },
            {
                path: "admin",
                loadChildren: "./pages/admin/admin.module#AdminModule",
            },
            {
                path: "quick",
                loadChildren:
                "./pages/quick-actions/quick-actions.module#QuickActionsModule",
            },
            {
                path: "quick/:id",
                loadChildren:
                "./pages/quick-actions/quick-actions.module#QuickActionsModule",
            },
            {
                path: "referEarn",
                component: ReferEarnComponent,
            },
            {
                path: "orders",
                loadChildren: "./pages/orders/orders.module#OrdersModule",
            },
            {
                path: "leads",
                loadChildren: "./pages/leads/leads.module#LeadsModule",
            },
            {
                path: "rates",
                loadChildren:
                "./components/rate/rate-table/rate-table.module#RateTableModule",
            },
            {
                path: "payment",
                loadChildren: "./pages/payment/payment.module#PaymentModule",
            },
            {
                path: "card",
                loadChildren: "./pages/card/card.module#CardsModule",
            },
            {
                path: "cardDistribution",
                loadChildren:
                "./pages/card-distribution/card-distribution.module#CardDistributionModule",
            },
            {
                path: "fxcManagement",
                loadChildren:
                "./pages/fxc-management/fxc-management.module#FxcManagementModule",
            },
            {
                path: "remittanceManagement",
                loadChildren:
                "./pages/remittance-management/remittance-management.module#RemittanceManagementModule",
            },
            {
                path: "",
                redirectTo: "dashboard",
                pathMatch: "full",
            },
        ],
    },
    {
        path: "**",
        redirectTo: "login",
        pathMatch: "full",
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CoreRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/core/core-routing.module.ts